module.exports = __webpack_public_path__ + "media/ice-climbers.6f65079d.wav";